import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MainHeader from '../components/MainHeader';
import Sidebar from '../components/Sidebar';
import MainFooter from '../components/MainFooter';
import Theming from '../components/Theming';
import Notification from '../components/Notification';
import Filter from '../components/Filter';

const InternalLayout: React.FC = () => {

    const adjustPadding = () => {
        // Use requestAnimationFrame to batch DOM operations
        requestAnimationFrame(() => {
            // Phase 1: Batch all DOM reads
            const headerElement = document.querySelector(".adminuiux-header .navbar") as HTMLElement;
            const sidebarPadding = document.querySelector(".adminuiux-sidebar") as HTMLElement;
            const contentPadding = document.querySelector(".adminuiux-content") as HTMLElement;
            const footerMobileElement = document.querySelector(".adminuiux-mobile-footer") as HTMLElement;

            const headerHeight = headerElement?.offsetHeight || 0;
            const footerMobileHeight = footerMobileElement?.offsetHeight || 0;

            // Phase 2: Batch all DOM writes in the same frame
            if (headerElement && sidebarPadding && contentPadding && headerHeight > 0) {
                contentPadding.style.paddingTop = `${headerHeight}px`;
                sidebarPadding.style.paddingTop = `${headerHeight}px`;
            }

            if (footerMobileElement && footerMobileHeight > 0) {
                document.body.style.paddingBottom = `calc(${footerMobileHeight}px + 10px + env(safe-area-inset-bottom))`;
            } else {
                document.body.style.paddingBottom = "0";
            }
        });
    };

    useEffect(() => {
        adjustPadding();
        window.addEventListener('resize', adjustPadding);

        const onScroll = () => {
            const headerElement = document.querySelector(".adminuiux-header");
            if (headerElement) {
                if (window.pageYOffset > 30) {
                    headerElement.classList.add("active");
                } else {
                    headerElement.classList.remove("active");
                }
            }
        };
        window.addEventListener('scroll', onScroll);

        return () => {
            window.removeEventListener('resize', adjustPadding);
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    const contentClick = () => {
        const windowWidth = window.innerWidth;
        const body = document.body;

        if (windowWidth < 992) {
            body.classList.remove("sidebar-open");
            body.classList.add("sidebar-close");
        }
    };

    return (

        <>
            {/* header */}
            <div className="adminuiux-header inner-page">
                <MainHeader />
            </div>

            <div className="adminuiux-wrap">
                {/* sidebar */}
                <Sidebar />
                {/* page content */}
                <main className="adminuiux-content has-sidebar" onClick={contentClick}>
                    <Outlet />
                </main>
            </div>

            {/* color change pallette */}
            <div className="offcanvas offcanvas-end shadow border-0 width-280" id="theming" data-bs-scroll="true" data-bs-backdrop="false" aria-labelledby="theminglabel">
                <Theming />
            </div>

            {/* notification */}
            <div className="offcanvas offcanvas-end shadow border-0 width-300" id="notification" data-bs-scroll="true" data-bs-backdrop="false" aria-labelledby="notificationlabel">
                <Notification />
            </div>

            {/* filter */}
            <Filter />

            {/* standard footer */}
            <MainFooter />
        </>
    );
};

export default InternalLayout;
